import { Chip } from '@mui/material';

import type { DeviceStatusProps } from './DeviceStatusChip.types';
import getDeviceStatusColor from './DeviceStatusColor.utils';

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    unknown: true;
    new: true;
    disabled: true;
  }
}

const DeviceStatusChip = (props: DeviceStatusProps) => {
  const { status } = props;

  return (
    <Chip
      label={`${status}`}
      variant="outlined"
      color={getDeviceStatusColor(status)}
      size="small"
    />
  );
};
export default DeviceStatusChip;
